module.exports = __webpack_public_path__ + "media/images/pic/teachers/marta-szulc-5b0789aff2f3501198de7e47455be826.png";